import { useAtom } from 'jotai';
import { authAtom } from '../Data/Atoms';
import { 
    extractClaims, 
    canAccessPath as canAccessPathHelper, 
    canPerformAction as canPerformActionHelper,
    Claims,
    Permission 
} from '../helpers/AuthorizationManager';

export function useAuthorization() {
    const [auth] = useAtom(authAtom);
    const claims = extractClaims(auth);

    return {
        canPerformAction: (action: Permission) => canPerformActionHelper(claims, action),
        canAccessPath: (path: string) => canAccessPathHelper(claims, path),
        claims,
    };
}

